// @vendors
const React = require('react');
const classNames = require('classnames');
const PropTypes = require('prop-types');

// @utils
const { FormattedText, formatText } = require('core/i18n').i18n;

// @commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKLink } = require('commonsComponents/OKLink');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @local
const ResultsRow = require('./fundsResultsRow');

// @constants
const RESULTS_PER_PAGE = 20;


class BrokerAdvancedSearchFundsResultsTable extends React.Component {
    constructor(props) {
        super(props);
        this.handleProductSelect = this.handleProductSelect.bind(this);
        this.handleShowMoreResults = this.handleShowMoreResults.bind(this);

        this.state = {
            resultsToShow: RESULTS_PER_PAGE,
            radioValue:'1'
        };
    }

    handleProductSelect(product) {
        this.props.onHandleProductSelect(product);
    }

    handleShowMoreResults() {
        const { resultsToShow } =this.state;
        this.setState({
            resultsToShow: (resultsToShow + RESULTS_PER_PAGE)
        });
    }

    radioTableRows(results) {
        const tableRows = results.map((result) => {
            const customInstitutionSecurityID = result.get('CustomInstitutionSecurityID');
            return (
                <ResultsRow
                    key={customInstitutionSecurityID}
                    item={result}
                    isModal={this.props.isModal}
                    onHandleProductSelect={this.handleProductSelect}
                    embeddedSearch={this.props.embeddedSearch}
                    isActive={this.props.selectedNewFund===customInstitutionSecurityID}
                    onWatchlistClick={this.props.onHandleWatchlistAdd}
                    deleteProductFromList={this.props.deleteProductFromList}
                />
            )
        });
        return tableRows;
    }

    tableHeaders() {
        const PREFIX = 'broker-searchResults';
        const nameLabel = formatText(`${PREFIX}NameLabel`);
        const categoryLabel = formatText(`${PREFIX}CategoryLabel`);
        const ratingLabel = formatText(`${PREFIX}FundsRatingLabel`);
        const riskLabel = formatText(`${PREFIX}RiskLabelFunds`);
        const earningsLabel = formatText(`${PREFIX}EarningsLabel`);
        const ytdLabel = formatText(`${PREFIX}YtdLabel`);
        const aYearLabel = formatText(`${PREFIX}AYearLabel`);
        const threeYearsLabel = formatText(`${PREFIX}ThreeYearsLabel`);
        const fiveYearsLabel = formatText(`${PREFIX}FiveYearsLabel`);
        const traspassableLabel = formatText(`${PREFIX}TraspassableLabel`);
        const downloadPDF = formatText(`${PREFIX}DownloadPDF`);
        const checkboxClass = classNames(
            'broker-search-results__table-first-column',
            {
                'broker-search-results__table-header-cell--radio' : this.props.embeddedSearch,
                'broker-search-results__table-header-cell--check' : !this.props.embeddedSearch
            }
        );
        const checkboxRow = (!this.props.isModal || this.props.embeddedSearch) ? <OKTableCell asHeader={true} className={checkboxClass}/> : undefined;
        const actionHeader = !this.props.embeddedSearch ? <OKTableCell asHeader={true} className="broker-search-results__table-header-cell--fund-action" /> : undefined;
        const nameClass = this.props.embeddedSearch ? "broker-search-results__table-header-cell--fund-name" : '';

        return (
            <React.Fragment>
                <div className="broker-search-results__table-header-divisor" />
                <OKTableRow asHeader={true} className="broker-search-results__table-header">
                    {checkboxRow}
                    <OKTableCell asHeader={true} className={nameClass}>
                        {nameLabel}
                    </OKTableCell>
                    <OKTableCell asHeader={true} width="10%">
                        {categoryLabel}
                    </OKTableCell>
                    <OKTableCell asHeader={true} width="8%">
                        {traspassableLabel}
                    </OKTableCell>
                    <OKTableCell
                        alignment="center"
                        asHeader={true}
                        width="10%"
                    >
                        {ratingLabel}
                    </OKTableCell>
                    <OKTableCell
                        alignment="center"
                        asHeader={true}
                        width="8%"
                    >
                        {riskLabel}
                        <OKTooltip
                            content="broker-searchResultsYtdTooltip"
                            offset={[0,-15]}
                        />
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        width="5%"
                    >
                        <span className="broker-search-results__table-header-earnings-title broker-search-results__table-header-earnings-title--funds">
                            {earningsLabel}
                            <hr className="broker-search-results__earnings-divider" />
                        </span>
                        {ytdLabel}
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        width="5%"
                    >
                        {aYearLabel}
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        width="6%"
                    >
                        {threeYearsLabel}
                    </OKTableCell>
                    <OKTableCell
                        alignment="right"
                        asHeader={true}
                        className="broker-search-results__table-header-cell--plan-five-year"
                        width="6%"
                    >
                        {fiveYearsLabel}
                    </OKTableCell>
                    <OKTableCell
                        alignment="center"
                        asHeader={true}
                        width="5%"
                    >
                        {downloadPDF}
                    </OKTableCell>
                    {actionHeader}
                </OKTableRow>
            </React.Fragment>

        );
    }

    tableHeadersForExternalFunds() {
        const PREFIX = 'broker-searchResults';
        const nameLabel = formatText(`${PREFIX}NameLabel`);
        return(
            <OKTableRow asHeader={true} className="broker-search-results__table-header">
                <OKTableCell asHeader={true} className="broker-search-results__table-header-cell--radio" />
                <OKTableCell asHeader={true} className="broker-search-results__table-header-cell--fund-name">
                    {nameLabel}
                </OKTableCell>
            </OKTableRow>
        );
    }

    tableRows(results, checkedList) {
        const { resultsToShow } = this.state;
        const { selectedNewFund } = this.props;
        const tableRows = results.slice(0, resultsToShow).map((result, index) => {
            const secId = result.get('secId');
            const uniqueId = `${result.get('productKey')}${index}`;

            return this.props.isModal ? (
                <ResultsRow
                    key={uniqueId}
                    item={result}
                    isModal={this.props.isModal}
                    onHandleProductSelect={this.handleProductSelect}
                    onWatchlistClick={this.props.onHandleWatchlistAdd}
                    deleteProductFromList={this.props.deleteProductFromList}
                    rowIndex={index}
                    watchlistEnabled={this.props.watchlistEnabled}
                    immExternalTransferFund={this.props.immExternalTransferFund}
                    isExternalFundsTransfer={this.props.isExternalFundsTransfer}
                    isActive={selectedNewFund && selectedNewFund.get('isin') === result.get('ISIN')}
                    />
            ) : (
                <ResultsRow
                    isActive={checkedList.includes(secId)}
                    key={uniqueId}
                    item={result}
                    checkedList={checkedList}
                    saveCheckedList={this.props.saveCheckedList}
                    onWatchlistClick={this.props.onHandleWatchlistAdd}
                    deleteProductFromList={this.props.deleteProductFromList}
                    rowIndex={index}
                    watchlistEnabled={this.props.watchlistEnabled}
                />
            );
        });
        return (tableRows)
    }
    showMoreResults(results) {
        const { resultsToShow } = this.state;
        if (results && resultsToShow < results.size) {
            return (
                <div className="broker-search-results__more-funds">
                    <OKLink modifier={'complementary'} onClick={this.handleShowMoreResults}>
                        <FormattedText
                            value="broker-moreFunds"
                            format={__CONTACT_CENTER__ ? "uppercase" : undefined}
                        />
                    </OKLink>
                </div>
            )
        }
        return null;
    }

    render() {
        const { results, checkedList, isExternalFundsTransfer} = this.props;
        const tableHeaders = isExternalFundsTransfer ? this.tableHeadersForExternalFunds() : this.tableHeaders();
        const tableRows = this.props.embeddedSearch
            ?  this.radioTableRows(results)
            : this.tableRows(results, checkedList);
        const showMoreResults = this.showMoreResults(results);
        const style = this.props.embeddedSearch ? {} : { overflowX: 'auto' };

        /**
         * @horizontal-scroll
         *
         * The result table has a container with an horizontal scroll and the
         * inner content is set to a fix width according to its size in
         * desktop.
         */
        return (
            <div  className="broker-search-results__table-wrapper" style={style}>
                <OKTable>
                    <thead>
                        {tableHeaders}
                    </thead>
                    <tbody>
                        {tableRows}
                    </tbody>
                </OKTable>
                {showMoreResults}
            </div>
        );
    }
}

BrokerAdvancedSearchFundsResultsTable.propTypes = {
    checkedList: PropTypes.object,
    deleteProductFromList: PropTypes.func,
    embeddedSearch: PropTypes.bool,
    isModal: PropTypes.bool,
    onHandleProductSelect: PropTypes.func,
    onHandleWatchlistAdd: PropTypes.func,
    results: PropTypes.object,
    saveCheckedList: PropTypes.func,
    searchState: PropTypes.object,
    selectedNewFund: PropTypes.string,
    watchlistEnabled: PropTypes.bool,
    isExternalFundsTransfer: PropTypes.bool,
    immExternalTransferFund: PropTypes.object
}

module.exports = BrokerAdvancedSearchFundsResultsTable;
